/* global BigInt */
import { alignObservations } from './energyMath';

export const floorSnapshotBoundary = (value) => new Date(Math.floor(Date.parse(value) / 10000) * 10000).toISOString();

export function validSection(section) {
  return section && (!Object.prototype.hasOwnProperty.call(section, 'dataStatus') || section.dataStatus === 'available');
}

export function alignInputs(inputs, boundary, options) {
  const usable = Object.fromEntries(Object.entries(inputs).map(([role, candidates]) => [role,
    (Array.isArray(candidates) ? candidates : [candidates]).filter(item => item && item.sampleTime != null
      && (item.dataStatus === undefined || item.dataStatus === 'available')).sort((a, b) =>
      Date.parse(b.row?.observedAt || b.sampleTime) - Date.parse(a.row?.observedAt || a.sampleTime)
      || (BigInt(b.row?.sequenceNumber || 0) > BigInt(a.row?.sequenceNumber || 0) ? 1 : BigInt(b.row?.sequenceNumber || 0) < BigInt(a.row?.sequenceNumber || 0) ? -1 : 0))]));
  return alignObservations(usable, floorSnapshotBoundary(boundary), options);
}

export function freshness(boundary, now = Date.now()) {
  const time = Date.parse(boundary);
  if (!Number.isFinite(time)) return { status: 'unavailable', ageSeconds: null, label: '-' };
  if (time > now + 10000) return { status: 'clockAnomaly', ageSeconds: Math.floor((now - time) / 1000), cutoffTime: boundary, label: 'Source clock ahead' };
  const ageSeconds = Math.max(0, Math.floor((now - time) / 1000));
  const status = ageSeconds <= 10 ? 'live' : ageSeconds <= 30 ? 'delayed' : 'stale';
  return { status, ageSeconds, cutoffTime: boundary,
    label: status === 'live' ? `Live (${ageSeconds}s)` : `${status === 'delayed' ? 'Delayed' : 'Stale'} (${ageSeconds}s)` };
}

export function readingFreshness(snapshot, now = Date.now()) {
  const rows = Object.values(snapshot?.aligned?.inputs || {}).map(input => input?.row).filter(Boolean);
  const simulated = rows.some(row => Object.values(row.payload || {}).some(value => value?.contractStatus === 'simulatorExpandedV2'));
  const receipts = rows.map(row => Date.parse(row.receivedAt)).filter(Number.isFinite);
  const receivedAt = simulated && receipts.length ? new Date(Math.max(...receipts)).toISOString() : null;
  return { ...freshness(receivedAt || snapshot?.boundary, now), cutoffTime: snapshot?.boundary,
    ...(simulated ? { clockBasis: 'simulator', receivedAt } : {}) };
}

// Retain a whole coherent balance, never a mixture of independently aged sources.
export function retainCoherentBalance(candidate, previous, now = Date.now()) {
  const snapshot = candidate?.aligned?.alignmentStatus === 'aligned' && candidate?.balance?.status === 'complete'
    ? candidate : previous || candidate;
  return { snapshot, freshness: readingFreshness(snapshot, now), retained: snapshot !== candidate };
}
